// extracted by mini-css-extract-plugin
export default {"Updateinfo":"index_Updateinfo_iptik"};